// productService.js

import axiosInstance from "../axiosInstance";
import omsAxiosInstance from "../omsAxiosInstance";

export const productService = {
  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/product/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (productData) => {
    try {
      let response = await axiosInstance.post("/product", productData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findAll: async (client_id, searchValue, query, signal) => {
    try {
      let api_query = `/product?`;
      if (client_id) {
        api_query += `&client_id=${client_id}`;
      }

      // Add search value
      if (searchValue) api_query += `&name[$search]=${searchValue}`;
      if (query.length) api_query += `&${query}`;
      if (!query.includes("$sort")) {
        api_query += `&$sort[createdAt]=-1`;
      }

      const response = await axiosInstance.get(api_query, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (client_id, searchValue, query, signal) => {
    try {
      let api_query = `/fetch-products?`;
      if (client_id) {
        api_query += `&client_id=${client_id}`;
      }

      // Add search value
      if (searchValue) api_query += `&name[$search]=${searchValue}`;
      if (query.length) api_query += `&${query}`;
      if (!query.includes("$sort")) {
        api_query += `&$sort[createdAt]=-1`;
      }

      const response = await axiosInstance.get(api_query, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchProductsPost: async (obj) => {
    try {
      let response = await axiosInstance.post("/fetch-products", {
        query: obj,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchOmsProducts: async (client_id, searchValue, query, signal) => {
    try {
      let api_query = `/product?`;

      if (client_id) {
        api_query += `client_id=${client_id}`;
      }

      if (searchValue) {
        api_query += `&name[$search]=${searchValue}`;
      }

      if (query.length) {
        api_query += `&${query}&$sort[createdAt]=-1`;
      }

      const response = await omsAxiosInstance.get(api_query, signal);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchSKU: async (
    clientId,
    searchValue,
    limit,
    skip,
    exclude_ids,
    supplier,
  ) => {
    try {
      let obj = {
        client_id: clientId,
        sku: searchValue,
        limit: limit || 15,
        skip: skip || 0,
        existing_ids: exclude_ids || [],
        supplier: supplier || null,
      };

      let response = await axiosInstance.post("/fetch-sku", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchById: async (id) => {
    try {
      let query = `/product/${id}?$populate=client_id&$populate=vendor&$populate=variants.product&$populate=category_id`;
      let response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/product/${id}`, {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/product/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteMultipleProduct: async (data) => {
    try {
      let response = await axiosInstance.post(`/delete-multiple-product`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  bulkUpload: async (data) => {
    const formData = new FormData();
    formData.append("file", data);
    try {
      let response = await axiosInstance.post("/product-bulk-upload", formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchBulkUploadData: async (limit, skip) => {
    try {
      let response = await axiosInstance.get(
        `/bulk-upload-status?$limit=${limit || 15}&$skip=${skip || 0}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchBulkUploadResult: async (id, limit, skip) => {
    try {
      let response = await axiosInstance.get(
        `/bulk-upload-results?$limit=${limit || 15}&$skip=${
          skip || 0
        }&status_id=${id}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  downloadSample: async () => {
    try {
      let response = await axiosInstance.post(`/download-product-sample`, {
        dataType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  syncProduct: async (data) => {
    try {
      let response = await axiosInstance.post(`/sync-product`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchTempProduct: async (limit, skip, client_id, searchValue) => {
    try {
      let query = `/temp-product?client_id=${client_id}&$limit=${
        limit || 15
      }&$skip=${skip || 0}`;
      if (searchValue) {
        query += `&$or[0][name][$search]=${searchValue}&$or[1][product_type][$search]=${searchValue}`;
      }
      let response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  discardAllTempProduct: async (data) => {
    try {
      let response = await axiosInstance.post(`/delete-temp-product`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  importAllProduct: async (data) => {
    try {
      let response = await axiosInstance.post(`/import-products`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCategory: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-category?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchNames: async (
    searchKey,
    client_id,
    limit = 15,
    skip = 0,
    excludeIds = [],
  ) => {
    // Feathers pagination requires $limit/$skip (plain limit/skip are ignored,
    // which leaves the service on its default page size and breaks Load More).
    let query = `$limit=${limit}&$skip=${skip}&$select[]=name&$select[]=variants`;
    if (client_id) {
      query += `&client_id=${client_id}`;
    }
    if (searchKey) {
      query += `&name[$search]=${searchKey}`;
    }
    if (excludeIds.length > 0) {
      query += excludeIds.map((x) => `&_id[$nin]=${x}`).join("");
    }
    try {
      let response = await axiosInstance.get(`/product?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchNamesByFilter: async (
    filterType,
    filterData,
    client_id,
    limit = 50,
    skip = 0,
  ) => {
    try {
      let query = `$limit=${limit}&$skip=${skip}&$select[]=name&$select[]=variants`;
      if (client_id) query += `&client_id=${client_id}`;
      if (
        filterType === "category" &&
        Array.isArray(filterData) &&
        filterData.length
      ) {
        if (filterData.length === 1) {
          query += `&product_type=${filterData[0]._id}`;
        } else {
          filterData.forEach((item, i) => {
            query += `&product_type[$in][${i}]=${item._id}`;
          });
        }
      }
      if (
        filterType === "supplier" &&
        Array.isArray(filterData) &&
        filterData.length
      ) {
        if (filterData.length === 1) {
          query += `&vendor=${filterData[0]._id}`;
        } else {
          filterData.forEach((item, i) => {
            query += `&vendor[$in][${i}]=${item._id}`;
          });
        }
      }
      if (
        filterType === "attribute" &&
        filterData.attributeType &&
        filterData.attributeValues?.length
      ) {
        query += `&variants.option.option_type=${filterData.attributeType}`;
        if (filterData.attributeValues.length === 1) {
          query += `&variants.option.value=${filterData.attributeValues[0]}`;
        } else {
          filterData.attributeValues.forEach((v, i) => {
            query += `&variants.option.value[$in][${i}]=${v}`;
          });
        }
      }
      let response = await axiosInstance.get(`/product?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  bulk_upload: async (data) => {
    try {
      let response = await omsAxiosInstance.post("/product-bulk-upload", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
